import { createStyles, rem } from '@mantine/core'

interface StylesParams {
  bgColor?: string
}

export default createStyles((theme, { bgColor }: StylesParams) => {
  return {
    root: {
      backgroundColor: bgColor || theme.colors.neutral[0],
      padding: `${rem(24)} 0`,
      [theme.fn.largerThan('sm')]: { padding: `${rem(80)} 0` },
    },
    heading: {},
  }
})
